@if (botlyContext()) {
<div class="text-end">
  <a
    class="text-decoration-none"
    [class.cursor-pointer]="!isBotlyLoading"
    [class.text-muted]="isBotlyLoading"
    (click)="this.openBotly()"
  >
    @if (isBotlyLoading) {
    <i class="botly me-1 botly-pulse"></i>
    <span i18n="@@botly-loading">Botly bereitet sich vor…</span>
    } @else {
    <i class="botly me-1"></i>
    <span i18n="@@ask-botly">Botly Fragen</span>
    }
  </a>
</div>
}
<div
  #codemirror
  class="form-control p-0"
></div>